







import { Component, Prop, Vue } from "vue-property-decorator";
import PTOViewEmployee from "@/components/payroll/policies/pto/PTOViewEmployee.vue";
import CompanyPTOPolicyList from "@/components/payroll/policies/pto/CompanyPTOPolicy.vue";
import PTOViewCompany from "@/components/payroll/policies/pto/PTOViewCompany.vue";

@Component({
	components: {PTOViewCompany, PTOViewEmployee, CompanyPTOPolicy: CompanyPTOPolicyList }
})
export default class PTOView extends Vue {
	@Prop({ default: null })
	private employmentId!: number | null;

	@Prop({ default: null })
	private companyId!: number | null;
}
